import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/button-icons/chevron-down-grey.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-37961cd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "aria-controls", "aria-label"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["id"]

import { computed, ref } from "vue";
import { Status } from "../../typings/shared/status";
import { Variant } from "../../typings/shared/levels-variant";

const REGULAR_WIDTH = "98%";
const HOVER_WIDTH = "100%";


export default /*#__PURE__*/_defineComponent({
  __name: 'completable-accordion',
  props: {
    id: {},
    status: {},
    isOpen: { type: Boolean },
    variant: {}
  },
  emits: ["accordionOpened", "accordionClosed"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "60d2e935": (accordionWidth.value)
}))

const props = __props;

const emit = __emit;

const onClick = () => {
  emit(props.isOpen ? "accordionClosed" : "accordionOpened", props.id);
};

const variantStyle = computed(() => {
  if (props.variant === "team") {
    return {
      "--bg-active": "#b0bb36",
      "--active-border": "solid 1px #b0bb36",
    };
  }
  if (props.variant === "user") {
    return {
      "--bg-active": "#FCAF17",
      "--active-border": "solid 1px #FCAF17",
    };
  }
  return {};
});

const accordionWidth = ref(REGULAR_WIDTH);

function onHover() {
  if (!props.isOpen) {
    accordionWidth.value = HOVER_WIDTH;
  }
}

function onHoverLeave() {
  if (!props.isOpen) {
    accordionWidth.value = REGULAR_WIDTH;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion", props.status]),
    style: _normalizeStyle(variantStyle.value)
  }, [
    _createElementVNode("button", {
      class: "accordion-header",
      onClick: onClick,
      onMouseover: onHover,
      onMouseleave: onHoverLeave,
      onFocus: onHover,
      onBlur: onHoverLeave,
      "aria-expanded": !!_ctx.isOpen,
      "aria-controls": 'content-' + props.id,
      "aria-label": `${_ctx.isOpen ? 'Collapse' : 'Expand'}`,
      type: "button",
      "data-test": "accordion-header"
    }, [
      _renderSlot(_ctx.$slots, "trigger"),
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: `chevron ${_ctx.isOpen ? 'up' : 'down'}`,
          class: _normalizeClass(["chevron-icon", props.status])
        }, null, 10, _hoisted_2)
      ])
    ], 40, _hoisted_1),
    _createVNode(_Transition, { name: "accordion" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "accordion-content",
          id: 'content-' + props.id,
          "data-test": "accordion-content"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_3), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
    })
  ], 6))
}
}

})